module.exports = __webpack_public_path__ + "img/prize-03.55182ad8.png";